import React, { useEffect, useRef, useState } from 'react'
import { getEntityPriority } from '../../../services/services';
import MarketDetailsFilters from './MarketDetailsFilters';
import { setOutletLevelTabsList } from '../../../../../stateManagement/actions/manageCouponActions';
import CouponLoader from '../../CouponLoader';
import { labelMappings } from '../../../utils/utils';
import { ConfirmationPopUp } from '../../../../../components/popup/confirmationPopUp';
import { getMultiSelectTabNames, getOutletTabsList } from './service';
import { OutletFiltersTypes } from '../../../types';
import { openPopup } from '../../../../../stateManagement/actions/popupActions';

let INITIAL_STATE: Record<string, any> = {}

/**
 * Market filter component
 * This component is responible for handling and data selection in Outlet selector
 * @param props 
 * @returns 
 */

function OutletFilters(props:OutletFiltersTypes) {
    const {handleChange,editMode, values,getOutletOptions,loading , outletCurrentTab,setOutletCurrentTab,outletLevelTabsList,multiple,arbitraryList,chipLimit,dataLimit, readOnly = false} = props;

    const [tabsLoading , setTabsLoading] = useState<boolean>(false);

    const [confirmationDetails , setConfirmationDetails] = useState<{message:string,open:boolean}>({message:'',open:false});
    const successMethodRef = useRef(()=>{});


    const getTabsList = async () => {
        setTabsLoading(true)
        try {
            const res = await getOutletTabsList();
            res.forEach((item: string) => {
                INITIAL_STATE[item] = []
            })
            handleChange && handleChange('schemeOutletBifurcations',INITIAL_STATE);
            setOutletLevelTabsList(res);
        } catch (error) {
			console.error(error);
		}finally{
            setTabsLoading(false);
        }
    }

    const handleTabChange = (event: React.SyntheticEvent, newValue: number): void => {
        setOutletCurrentTab(newValue);
    }

    const onSelect = (currentSelectedValues: string[], currentTabName: string) => {
        if (readOnly) return;

        const currentEntityPriority = getEntityPriority(currentTabName);
        let filteredData: Record<string, any> = { ...values.schemeOutletBifurcations };
        let isLowerPriorityRemoved = false;

        outletLevelTabsList.forEach((tab:string) => {
       
            // higher value means lower priority
            if(getEntityPriority(tab) > currentEntityPriority && filteredData[tab]?.length>0 ) {
                filteredData[tab] = [];
                isLowerPriorityRemoved = true;
            } else {
                filteredData[tab] = values.schemeOutletBifurcations[tab];
            }
        })
        let newVal:any;
        if(dataLimit && currentTabName==="outletCode"){
            if(currentSelectedValues.length<dataLimit+1){
                newVal = {...filteredData,[currentTabName]:currentSelectedValues}
            }else{
                openPopup("Error",`No. of outlet codes cannot be greater than ${dataLimit}`);
                return;
            }
        }else{
            newVal = {...filteredData,[currentTabName]:currentSelectedValues}
        }
        
        if(isLowerPriorityRemoved){
            // showing appropriate conformation message
            const msg = labelMappings["TABS_LOWER_PRIORITY_DATA_RESET"]
            successMethodRef.current = ()=>{
                handleChange('schemeOutletBifurcations',newVal);
            }
            setConfirmationDetails(()=>({message:msg,open:true}))            
        }else{
            handleChange('schemeOutletBifurcations',newVal);
        }
    }

    useEffect(() => {
        if(!editMode)   
            getTabsList();
    }, [])
   
    return (
        <div className='outlet-filters-wrapper'>
            {
                tabsLoading ? <CouponLoader /> :
                    <MarketDetailsFilters
                        arbitraryList={arbitraryList}
                        getTabContent={getOutletOptions}
                        tabsList={outletLevelTabsList}
                        handleTabChange={handleTabChange}
                        currentTab={outletCurrentTab}
                        onSelect={onSelect}
                        data={values.schemeOutletBifurcations}
                        combinedSelectedValues={values}
                        loading={loading}
                        filterName={"outlet"}
                        multiple={multiple}
                        chipLimit={chipLimit}
                        dataLimit={dataLimit}
                        readOnly={readOnly}
                    />
            }

            <ConfirmationPopUp
                message={confirmationDetails.message}
                openConfirmModal={confirmationDetails.open}
                setOpenConfirmModal={(val) => setConfirmationDetails(() => ({ message: "", open: val as boolean }))}
                successMethod={successMethodRef.current}
            />
        </div>
    )
}

export default OutletFilters